export const environment = {
  production: false,
  apiUrl: 'https://ecommerce.staging-arkifi.store', // Ecommerce.API URL - Staging
  storeEnvironment: 'Test' as const // Store/platform mode: Live | Test
};